<template>
  <va-list fit class="mb-2">
    <va-list-label>
      {{ $t('dashboard.table.noks') }}
    </va-list-label>
    <template v-for="(kin, i) in kins">
        <va-item>
          <va-item-section avatar>
            <avatar :username="kin.name" :color="spinnersColor"></avatar>
          </va-item-section>
          <va-item-section>
            <va-item-label>
              {{ kin.name }}
            </va-item-label>

            <va-item-label caption>
              {{ kin.relationship }}
            </va-item-label>

            <va-item-label>
             {{ kin.percentage}}
            </va-item-label>
          </va-item-section>

          <va-item-section side v-if="kin.isbeneficiary">
            <va-icon name="fa fa-check"/>
          </va-item-section>
        </va-item>
    </template>
  </va-list> 
</template>

<script>
import axios from 'axios'
import Avatar from 'vue-avatar'

export default {
  components: {
    Avatar,
  },
  data () {
    return {
      trans: {},
      loading: false,
      spinnersColor: this.$themes.primary,
      kins:{},
      term: null,
      mode: 0,
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
    }
  },
  created () {
    this.getNextOfKins()
  }, 
  
  methods: {
    getNextOfKins () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}getnextofkins`, this.userData.user_id, config)
        .then(function (res) {
          res = res.data 
          self.kins = res      
        })
        .catch(function (error) {
          console.log(error)
        })
    }    
  },
}
</script>

<style lang="scss">
</style>
